import FormFieldCheck from '@/gavnoCode/requestFormFieldCheck';
import myApi from '@/gavnoCode/ApiHandler';

const getDefaultState = () => {
  return {
    sendData: {
      request: {
        BIRTHDAY: '',
        BIRTHPLACE: '',
        CALC_SUMM: '',
        CALC_WEEK: '',
        CAR_NUMBER: '',
        CONST_INCOME: '',
        CREDHISTORY_RADIO: '',
        EMAIL: '',
        EXPER_RADIO: '',
        FIRST_NAME: '',
        GENDER: '',
        IS_ADDRESS_COINCIDES: 'N',
        IS_I_CERTIFY_REGISTRATION: 'Y',
        LAST_NAME: '',
        MEETING_DATE: '',
        MEETING_HOUR: '',
        OTHER_SOURCES_OF_INCOME: '',
        PASSPORT_DATE: '',
        PASSPORT_DEP: '',
        PASSPORT_DEP_CODE: '',
        PASSPORT_NUMBER: '',
        PASSPORT_SERIES: '',
        PHONE: '',
        PRODUCT_ID: 'K',
        REGISTRATION_ADDRESS: '',
        REGISTRATION_ADDRESS_DADATA: '',
        RESIDENTIAL_ADDRESS: '',
        RESIDENTIAL_ADDRESS_DADATA: '',
        SECOND_NAME: '',
        WORK_JOB: '',
        WHERE_TO_FIND_US:'',
        REFFER:'',
        VIDEO_SCORING:false,
        VIDEO_SCORING_AVAILABILITY:-1,
      },
      status:{
        CallStatus: '',
        SubCallStatus: '',
        OperatorMsg: '',
        ReCallDate: '',
        ReCallTime: '',
        KoMain: '',
        KoSub: '',
        KoResult: '',
        requestType:''
      },
      LeadInfo:{
        LeadGUID:'',
        LeadType:'',
        PHONE_ADDITIONAL:'',
        PHONE_FOR_CALL:''
      }
    },
    workData: {
      request: {
        BIRTHDAY: {code: 1, msg: 'обязательное поле'},
        BIRTHPLACE: {code: 1, msg: 'обязательное поле'},
        CALC_SUMM: {code: 0, msg: 'обязательное поле'},
        CALC_WEEK: {code: 0, msg: ''},
        CAR_NUMBER: {code: 0, msg: ''},
        CONST_INCOME: {code: 1, msg: 'обязательное поле'},
        CREDHISTORY_RADIO: {code: 1, msg: 'обязательное поле'},
        EMAIL: {code: 1, msg: 'обязательное поле'},
        EXPER_RADIO: {code: 1, msg: 'обязательное поле'},
        FIRST_NAME: {code: 1, msg: 'обязательное поле'},
        GENDER: {code: 1, msg: 'обязательное поле'},
        IS_ADDRESS_COINCIDES: {code: 0, msg: ''},
        IS_I_CERTIFY_REGISTRATION: {code: 0, msg: ''},
        LAST_NAME: {code: 1, msg: 'обязательное поле'},
        MEETING_DATE: {code: 1, msg: 'обязательное поле'},
        MEETING_HOUR: {code: 1, msg: 'обязательное поле'},
        OTHER_SOURCES_OF_INCOME: {code: 1, msg: 'обязательное поле'},
        PASSPORT_DATE: {code: 1, msg: 'обязательное поле'},
        PASSPORT_DEP: {code: 1, msg: 'обязательное поле'},
        PASSPORT_DEP_CODE: {code: 1, msg: 'обязательное поле'},
        PASSPORT_NUMBER: {code: 1, msg: 'обязательное поле'},
        PASSPORT_SERIES: {code: 1, msg: 'обязательное поле'},
        PHONE: {code: 1, msg: 'обязательное поле'},
        PRODUCT_ID: {code: 0, msg: ''},
        REGISTRATION_ADDRESS: {code: 1, msg: 'обязательное поле'},
        REGISTRATION_ADDRESS_DADATA: {code: 0, msg: 'обязательное поле'},
        RESIDENTIAL_ADDRESS: {code: 1, msg: 'обязательное поле'},
        RESIDENTIAL_ADDRESS_DADATA: {code: 0, msg: 'обязательное поле'},
        SECOND_NAME: {code: 1, msg: 'обязательное поле'},
        WORK_JOB: {code: 1, msg: 'обязательное поле'},
        WHERE_TO_FIND_US:{code: 0, msg: ''},
        REFFER:{code: 0, msg: ''},
        VIDEO_SCORING:{code:0, msg:''},
      },
      status:{
        CallStatus: {code: 1, msg: 'обязательное поле'},
        SubCallStatus: {code: 0, msg: ''},
        OperatorMsg: {code: 0, msg: ''},
        ReCallDate: {code: 0, msg: ''},
        ReCallTime: {code: 0, msg: ''},
        KoMain: {code: 0, msg: ''},
        KoSub: {code: 0, msg: ''},
        KoResult: {code: 0, msg: ''},
        requestType: {code: 0, msg: ''}
      },
      LeadInfo:{
        LeadGUID:{code: 0, msg: ''},
        LeadType:{code: 0, msg: ''},
        PHONE_ADDITIONAL:{code: 0, msg: ''},
        PHONE_FOR_CALL:{code: 0, msg: ''},
      }
    },
    videoScoring: {
      demandRequestGuid: '',
      demandId: 0,
      demandStatus: '',
    }
  }
};

function transformValueBeforeSave (workArr){
  let phoneFieldArr = ['PHONE','PHONE_ADDITIONAL','PHONE_FOR_CALL'];

  if (phoneFieldArr.includes(workArr.target) && workArr.value.length == 10) {
    let str = workArr.value;
    workArr.value = '+7 (' + str.slice(0,3) + ') ' + str.slice(3,6) + '-' + str.slice(6,8) + '-'  + str.slice(8,10);
  }

  return workArr.value;
};

const state = getDefaultState();

const getters = {
  getTargetFieldValue: (state) => (target) => state.sendData['request'][target],
  canSaveRequest:(state) => {
    let counter = 0;
    for (let key in state.workData.request){
      counter += Math.abs(state.workData.request[key]['code']);
    }
    if (counter == 0) {
      return true;
    } else {
      return false;
    }
  },
  canSaveKo:(state) => {
    if (state.sendData.status.CallStatus == 'Нет связи с клиентом'
      || state.sendData.status.CallStatus == 'Номер не принадлежит клиенту'
      || state.sendData.status.CallStatus == 'Перезвонить') {
      return true;
    } else {
      if (state.sendData.status.KoMain == 'Заявку оставлял') {
        if (state.sendData.status.KoResult.length > 0 && state.sendData.status.KoSub.length > 0) {
          return true;
        }
      } else if(state.sendData.status.KoMain.length > 0) {
        return true;
      }
      return false;
    }
  },
  isVideoScoringActive: (state) => state.sendData.request.VIDEO_SCORING,
  getDemandIdMsg:(state)=>{
    if (state.videoScoring.demandId == 0) {
      return 'Идет сохранение заявки';
    } else {
      return state.videoScoring.demandId;
    }
  },
  getDemandStatusMsg:(state)=>{
    if (state.videoScoring.demandStatus == '') {
      return 'Ожидание получения статуса заявки';
    } else {
      return state.videoScoring.demandStatus;
    }
  },
  isPDL:(state)=>{
    return state['sendData']['LeadInfo']['LeadType'] == 'PDL-2'
      || state['sendData']['LeadInfo']['LeadType'] == 'PDL-1'
      || state['sendData']['LeadInfo']['LeadType'] == 'PDL+1';
  },
  outScriptsId:(state)=>{
    switch (state['sendData']['LeadInfo']['LeadType']) {
      case 'PDL-2':
        return '115';
        break;
      case 'PDL-1':
        return '116';
        break;
      case 'PDL+1':
        return '117';
        break;
      default:
        return '1';
        break;
    }
  }
};

const actions = {
  setRequestField: ({commit, dispatch}, requestFields) => {
    try{
      Object.keys(requestFields.values).forEach(function (key) {
        if (key in state.sendData[requestFields.form]) {
          if (requestFields.values[key] !== state.sendData[requestFields.form][key]) {
            dispatch('saveSendData',{
              target:key,
              value:requestFields.values[key],
              form:requestFields.form
            });
          }
        }
      });
    }catch (e) {
      // alert('!!!!! СКОПИРОВАТЬ и ОТПРАВИТЬ РАЗРАБОТЧИКУ !!!!! ->> ' + JSON.stringify(requestFields) + ' #### ' +
      //   JSON.stringify(e));
      console.log(e);
    }

  },
  saveSendData: ({commit, dispatch}, workArr) => {
    if(workArr.value === undefined) {return false;}
    workArr.value = transformValueBeforeSave(workArr);



    if (state.sendData[workArr.form][workArr.target] === workArr.value || workArr.value === '') {
      return false;
    }
    let statusArr = {};
    if (typeof FormFieldCheck[workArr.target] == 'function') {
      statusArr = FormFieldCheck[workArr.target](workArr.value);
    } else {
      statusArr = FormFieldCheck.isEmpty(workArr.value);
    }
    workArr['status'] = statusArr;

    //todo переписать и найти решение, проблема как указать дерективу на инпут с уникальным шаблоном маски, если не каждому инпуту нужна такая директива.
    if (typeof FormFieldCheck[workArr.target + 'maskKostil'] == 'function') {
      workArr.value = FormFieldCheck[workArr.target + 'maskKostil'](workArr.value);
    }
    commit('saveSendData', workArr);
    commit('saveWorkData', workArr);

  },
  resetToDefault:({commit}) => {
    return new Promise(resolve => {
      commit('resetState');
      resolve();
    });
  },
  isAdressConsides:({commit}) => {
    // debugger;
    let workArr ={
      target:'REGISTRATION_ADDRESS_DADATA',
      form:'request',
      value: ''
    };
    let statusArr = {};
    if (state.sendData.request.IS_ADDRESS_COINCIDES === 'Y') {
      workArr.value = state.sendData.request.RESIDENTIAL_ADDRESS_DADATA;
      if (typeof FormFieldCheck[workArr.target] == 'function') {
        statusArr = FormFieldCheck[workArr.target](workArr.value);
      } else {
        statusArr = FormFieldCheck.isEmpty(workArr.value);
      }
      workArr['status'] = statusArr;
      commit('saveSendData', workArr);
      commit('saveWorkData', workArr);

      workArr.target = 'REGISTRATION_ADDRESS';
      workArr.value = state.sendData.request.RESIDENTIAL_ADDRESS;
      if (typeof FormFieldCheck[workArr.target] == 'function') {
        statusArr = FormFieldCheck[workArr.target](workArr.value);
      } else {
        statusArr = FormFieldCheck.isEmpty(workArr.value);
      }
      workArr['status'] = statusArr;
      commit('saveSendData', workArr);
      commit('saveWorkData', workArr);
    }
  },
  saveRequestGuid: ({commit}, RequestResult) => {
    if (RequestResult.RequestID != undefined) {
      commit('setRequestGuid', RequestResult.RequestID);
    }
  },
  saveDemand:({commit}, demand)=>{
    return new Promise((resolve, reject) => {
      if(parseInt(demand, 10) > 0) {
        commit('setDemand',demand);
        resolve();
      } else {
        reject();
      }
    });
  },
  saveStatusDemand:({commit}, statusDemand)=>{
    return new Promise((resolve, reject) => {
      if (statusDemand != undefined) {
        commit('setDemandStatus', statusDemand);
      } else {
        reject();
      }
    });
  }
};

const mutations = {
  saveSendData: (state, newVal) => state.sendData[newVal.form][newVal.target]= newVal.value,
  saveWorkData: (state, newVal) => state.workData[newVal.form][newVal.target]= newVal.status,
  resetState: (state) => Object.assign(state, getDefaultState()),
  setRequestGuid: (state, value) => state.videoScoring.demandRequestGuid = value,
  setDemand:(state, value) => state.videoScoring.demandId = value,
  setDemandStatus:(state, value) => state.videoScoring.demandStatus = value,
};

const namespaced = true;


export default {
  state,
  getters,
  actions,
  mutations,
  // namespaced
}
